import { render, staticRenderFns } from "./big-screen-model.vue?vue&type=template&id=34e888d4&scoped=true&"
import script from "./big-screen-model.vue?vue&type=script&lang=js&"
export * from "./big-screen-model.vue?vue&type=script&lang=js&"
import style0 from "./big-screen-model.vue?vue&type=style&index=0&id=34e888d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e888d4",
  null
  
)

export default component.exports